import { useState } from 'react';
import { AxiosRequestConfig } from 'axios';
import { axiosInstance } from '../../../utils/axiosInstance';

import { Col, Button, Row, Card, CardBody, Typography } from 'darrius';

import { showToast } from '../../../components/atoms/Toast/Toast';
import { Dialog } from '../../../components';
import { AdsDetailDialog } from './AdsDetailDialog';
import { AdsMessageDialog } from './AdsMessageDialog';

import { triggerEvent } from '../../../utils/triggerEvent';

import { IUserTransformationReturn } from '../../../modules/profile/shared/transformations/user/@interfaces';
import { IInstantMatchPagePropsReturn } from '../../../modules/instantMatch/pageProps';

import styles from './AdsPriceCards.module.scss';

interface IAdsPriceCards {
  adsPageProps: IInstantMatchPagePropsReturn;
  user: IUserTransformationReturn;
  pricesCard: {
    id: string | number;
    title: string;
    description: string;
    price_label: string;
    price: string;
  }[];
  requestId: string;
  profileId: string;
  isUserCliAuthenticated: boolean;
  requestUuid: string;
}

export function AdsPriceCards({
  adsPageProps,
  isUserCliAuthenticated = false,
  pricesCard,
  requestId,
  profileId,
  requestUuid,
}: IAdsPriceCards) {
  const { user, isSentMessage } = adsPageProps;
  const [selectedService, setSelectedService] = useState(null);
  const [isPayingForProfileService, setIsPayingForProfileService] =
    useState(false);

  const handleServiceChange = (pricesCard, index) => {
    setSelectedService(pricesCard);
    triggerEvent('instant-match_service-sale-ads__radius', {
      requestId: requestId,
      profileId: profileId,
      cardPosition: (index + 1).toString(),
    });
  };

  const handleTriggerEventClickButton = (_, index) => {
    triggerEvent('instant-match_service-sale-ads__price-card-detail', {
      requestId: requestId,
      profileId: profileId,
      cardPosition: (index + 1).toString(),
    });
  };

  const adsMessageDialogData = {
    user,
    requestId,
    isUserCliAuthenticated,
    isSentMessage,
  };

  async function handlePayForProfileService() {
    triggerEvent('instant-match_service-sale-ads__checkout-payment', {
      requestId: requestId,
      profileId: profileId,
      price: selectedService.price_label,
    });

    try {
      setIsPayingForProfileService(true);

      const requestOptions: AxiosRequestConfig = {
        url: `${process.env.NEXT_PUBLIC_API_PRO}/purchase/ads`,
        method: 'POST',
        data: {
          requestId: Number(requestId),
          profileId: Number(profileId),
          priceServiceId: Number(selectedService.id),
          priceService: Number(selectedService.price),
        },
      };

      const { data } = await axiosInstance<any>(requestOptions);

      if (data.status && data.status === 'error' && data.message) {
        showToast({ message: data.message, type: 'error' });

        return;
      }

      if (data.url) {
        window.location.href = data.url;

        return;
      }

      showToast({
        message: 'Ocorreu um erro ao tentar contratar o serviço',
        type: 'error',
      });

      setIsPayingForProfileService(false);
    } catch (error) {
      showToast({ message: error.response.data.message, type: 'error' });

      setIsPayingForProfileService(false);
    }
  }

  return (
    <section className={styles['ads-price-cards']}>
      {pricesCard.map((card, index) => {
        return (
          <Row key={card.id}>
            <Col>
              <Card
                className={
                  selectedService &&
                  selectedService.id === card.id &&
                  styles['border-selected']
                }
              >
                <CardBody>
                  <div className={styles['radio-title']}>
                    <label>
                      <input
                        key={index}
                        type="radio"
                        name="service"
                        value={card.title}
                        onChange={() => handleServiceChange(card, index)}
                      />
                      <div>
                        <Typography.Subtitle size="m">
                          {card.title}
                        </Typography.Subtitle>
                        <Typography.Text className={styles.text}>
                          {card.price_label}
                        </Typography.Text>
                      </div>
                    </label>
                  </div>
                  <hr className={`${styles['soft-line']}`} />

                  <Row>
                    <Col className={`${styles['head-details']} col-12`}>
                      <div className={styles['title-description']}>
                        <span
                          className={`space-bottom about-title-description ${styles['about-title-description']}`}
                        >
                          Esse serviço atende:
                        </span>
                      </div>
                      <div className={styles['detail-button']}>
                        <Dialog.Root>
                          <Dialog.Trigger asChild>
                            <Button.Root
                              variation="clear"
                              size="small"
                              onClick={() =>
                                handleTriggerEventClickButton('', index)
                              }
                            >
                              Ver tudo
                            </Button.Root>
                          </Dialog.Trigger>
                          <AdsDetailDialog
                            avatar={user.avatar}
                            category={user.description}
                            name={user.name}
                            description={card.description}
                            requestId={requestId}
                            profileId={profileId}
                          />
                        </Dialog.Root>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className={styles['title-description']}>
                        <span
                          className={`about-description ${styles['about-description']}`}
                        >
                          {card.description}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        );
      })}
      <Row>
        <Col>
          <AdsMessageDialog
            adsMessageDialogData={adsMessageDialogData}
            isSentMessageSuccess={isSentMessage}
            requestUuid={requestUuid}
          />
        </Col>
      </Row>
      {selectedService ? (
        <Row>
          <Col className="col-sm-12 col-md-7">
            <Button.Root
              fullWidth
              size="small"
              disabled={isPayingForProfileService}
              isLoading={isPayingForProfileService}
              onClick={handlePayForProfileService}
            >
              Pagar {selectedService.price_label}
            </Button.Root>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col className="col-sm-12 col-md-7">
            <Button.Root fullWidth disabled={true} size="small">
              Selecione um serviço
            </Button.Root>
          </Col>
        </Row>
      )}
    </section>
  );
}
